export const MONTH_ARR = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const getDateRange = (startOffsetDays: number, endOffsetDays: number) => {
  const today = new Date();
  const startDate = new Date(
    today.getTime() + startOffsetDays * 24 * 60 * 60 * 1000,
  );
  const endDate = new Date(
    today.getTime() + endOffsetDays * 24 * 60 * 60 * 1000,
  );
  return { startDate, endDate };
};

export const calculateAll = () => ({ startDate: null, endDate: null });

export const calculateToday = () => {
  const today = new Date();
  const startDate = new Date(today.setHours(0, 0, 0, 0));
  const endDate = new Date(today.setHours(23, 59, 59, 999));
  return { startDate, endDate };
};
export const calculate7Days = () => getDateRange(-6, 0);

export const calculate1Month = (isFuture: boolean) => {
  const today = new Date();
  const startDate = new Date(today);
  const endDate = new Date(today);

  if (isFuture) {
    endDate.setMonth(today.getMonth() + 1);
  } else {
    startDate.setMonth(today.getMonth() - 1);
  }

  return { startDate, endDate };
};
